import { useState } from "react";
import toast from "react-hot-toast";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import axiosInstance, { adminurl, Homeurl, keyLogin, LiveURL, TestURL, weburl } from "../../axiosInstance";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { encrypt } from "../../helper/encryption";
import setCookie from "../../helper/setCookie";
import getDecryptData from "../../helper/getDecryptData";
import { useBlogContext } from "../../fetchdata/BlogContext";
import { decryptApi } from '../components/extra/encryptionApi'

const CheckoutPlan = () => {
  const APIKEY = keyLogin;

  const {
    Headers,

  } = useBlogContext();

  const { id } = useParams();



  const [PlanData, setPlanData] = useState([]);
  const [UserData, setUserData] = useState([]);

  const [PlanLoading, setPlanLoading] = useState(true);


  // Fetch all plans data
  const fetchPlanData = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(`/all-plan`);
      setPlanData(response.data?.plan);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  const GetUser = async () => {
    const decryptdatajson = await getDecryptData();
    if (decryptdatajson && decryptdatajson?._id) {
      if (!decryptdatajson.email) {
        navigate('/account/profile')
      }
      setUserData(decryptdatajson);
    } else {
      setUserData([]);
    }
  }
  useEffect(() => {
    fetchPlanData();
    GetUser();
  }, []);




  const navigate = useNavigate();

  const [loading, setLoading] = useState(true); // Add loading state

  const [SubmitLoading, setSubmitLoading] = useState(true); // Add loading state
  const [data, setData] = useState([]);
  const [filteredCities, setFilteredCities] = useState([]);

  const [inputs, setInputs] = useState({
    type: "2",
    username: "",
    phone: "",
    email: "",
    password: "",
    confirm_password: "",
    pincode: "",
    Gender: "1",
    DOB: "",
    address: "",
    plan: id,
  });

  // //handle input change
  // const handleChange = (e) => {
  //     const { name, value, type, checked, files } = e.target;
  //     setInputs((prevData) => ({
  //         ...prevData,
  //         [name]:
  //             type === "checkbox" ? checked : type === "file" ? files[0] : value,
  //     }));
  // };

  const capitalizeEachWord = (str) => {
    if (!str) return str;
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    let newValue;
    if (type === "checkbox") {
      newValue = checked;
    } else if (type === "file") {
      newValue = files[0];
    } else {
      newValue = value;
    }

    // Capitalize text for the 'username' field
    if (name === "username") {
      newValue = capitalizeEachWord(newValue);
    }
    // Capitalize text for the 'username' field
    if (name === "state") {
      const selectedState = data.find((state) => state._id === newValue);
      if (selectedState) {
        setFilteredCities(selectedState.cities);
        setInputs((prevData) => ({
          ...prevData,
          statename: selectedState.name,
          city: "",
        }));
      }
      console.log("selectedState", selectedState, newValue, data);
    }

    setInputs((prevData) => ({
      ...prevData,
      [name]: newValue,
    }));
  };

  const [showPassword, setShowPassword] = useState(false);
  const [GetOtpRes, setOtpRes] = useState(null);

  const [OTPVerify, setOTPVerify] = useState(false);
  const [ExistingUser, setExistingUser] = useState([]);

  
  // Function to toggle password visibility
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };



  
    const submitOTP = async (phone) => {
      if (!phone) {
        toast.error('Please Enter a phone number.');
        return null;

      } else if (phone.length !== 10) {
        toast.error('Please Enter a 10-digit phone number.');
        return null;
      }  
      setSubmitLoading(false); // Set loading to true before making the request
      const inputs = {
        phone:phone
      }
      setOtpRes(null);
      try {
        const response = await axiosInstance.post(`/signup-login-new/`, inputs); // Await the axios post request
        console.log('responseresponse', response)
        setOtpRes(response.data); // Set the response data to state
        // console.log('dataotp', response.data.password);
        const { existingUser} = response.data;
        if(existingUser){
          setExistingUser(existingUser);
        }

      } catch (error) {
        console.error('Error On taxes:', error);
        toast.error(error.response.data.message);
      } finally {
        setSubmitLoading(true); // Set loading to false after request completion
      }
    };

    
      const verifyOTPFinal = async () => {
        setSubmitLoading(false); // Set loading to false after request completion
    
        const MYOTPinputs = { OTP: inputs.otp, HASHOTP: GetOtpRes.otp }
    
        try {
          const response = await axiosInstance.post(`/login-verify-otp`, MYOTPinputs); // Await the axios post request
          console.log('responseresponse', response)
          const { success } = response.data
          if (success) {
    
            setOTPVerify(true);
    
          }
        } catch (error) {
          console.error('Error On OTP Verify:', error);
          toast.error(error.response.data.message);
          setOTPVerify(false);

        } finally {
          setSubmitLoading(true); // Set loading to false after request completion
        }
     
      }


  const handleSubmit_old = async () => {
    setSubmitLoading(false);

    if ((PlanData.find(row => row._id === inputs.plan)?.price || 0) * 1.18 === 0) {
      toast.error('Please Choose a plan');
      setSubmitLoading(true);

      return null;

    }

    console.log(inputs);

    if (UserData._id) {

    } else {

      const fields = [
        { name: "username", message: "Please enter full name" },
        { name: "phone", message: "Please enter phone number" },
        { name: "email", message: "Please enter email" },
        { name: "password", message: "Please enter password" },
        { name: "confirm_password", message: "Please enter confirm password" },
        { name: "state", message: "Please enter State" },
        { name: "city", message: "Please enter State" },
        { name: "pincode", message: "Please enter pincode" },
        { name: "address", message: "Please enter address" },
        // Fields below are conditionally required based on inputs.type
        ...(inputs.type !== "3"
          ? [
            { name: "Gender", message: "Please enter Gender" },
            { name: "DOB", message: "Please enter DOB" },
          ]
          : []),
      ];

      for (const field of fields) {
        if (!inputs[field.name]) {
          toast.error(field.message);
          setSubmitLoading(true);
          return;
        }
      }

      if (inputs.password !== inputs.confirm_password) {
        toast.error("Password does not match");
        setSubmitLoading(true);
        return;
      }

      // Email Validation (basic regex)
      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      if (!emailRegex.test(inputs.email)) {
        toast.error("Please enter a valid email address");
        setSubmitLoading(true);
        return;
      }

      // DOB Validation (age 18+)
      let dob = new Date(inputs.DOB);
      let today = new Date();
      let age = today.getFullYear() - dob.getFullYear();
      let m = today.getMonth() - dob.getMonth();

      if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) {
        age--;
      }

      // if (age < 18) {
      //   toast.error("You must be at least 18 years old");
      //   setSubmitLoading(true);
      //   return;
      // }



      // const response = await axiosInstance.post("/api/get-key", inputs);

      // console.log('response', response)
      // return null;
      // console.log("mydata", inputs);
      const updatedFormData = {
        ...inputs,
        planId: inputs?.plan,
        totalAmount: (PlanData.find(row => row._id === inputs.plan)?.price || 0) * 1.18,
      };


      try {
        const {
          data: { order },
        } = await axiosInstance.post(
          `/buy-plan-add-user`,
          updatedFormData
          //    {
          //   headers: {
          //     "Content-Type": "multipart/form-data",
          //   },
          // }
        );
        const { success, user } = data;
        if (success) {

          const { _id, username, email, type, phone } = user;
          const userToStore = { _id, username, email, type, phone };

          //  localStorage.setItem('user', JSON.stringify(userToStore));
          const encrptdata = encrypt(JSON.stringify(userToStore), keyLogin);

          setCookie('token', encrptdata, 7); // Expires in 7 days

          const options = {
            key: 'finalkey',
            amount: order.amount,
            currency: "INR",
            name: "Ynbhealthcare",
            description: "Ynbhealthcare",
            image: "https://backend-2o7f.onrender.com/uploads/new/image-1726306777273.webp",
            order_id: order.id,
            callback_url: `${Homeurl}paymentverification-wallet`,
            // prefill: {
            //   name: "test gupta",
            //   email: "test@gmail.com",
            //   contact: "1234567890",
            // },
            notes: {
              address: "razorapy official",
            },
            theme: {
              color: "#3399cc",
            },
          };
          const razor = new window.Razorpay(options);
          razor.open();

          // toast.success("Plan Created Successfully  ");
          // navigate('/account/plan')
          // setTimeout(() => {
          //   window.location.href = adminurl;

          // }, 1000);
        }
      } catch (error) {
        console.error("Error On Signup:", error);
        toast.error(error.response.data.message);
        setSubmitLoading(true);

      } finally {
        setSubmitLoading(true);
      }


    }

    setSubmitLoading(true);
  };

  const handleSubmit = async () => {

    if(!OTPVerify && !UserData){
      toast.error('Please verify OTP first');
      return null;
    }

    // Start loading before the submission process
    setSubmitLoading(false);

    // Check if a plan is selected and its price is valid
    const selectedPlan = PlanData.find(row => row._id === inputs.plan);
    if (!selectedPlan || selectedPlan.price * 1.18 === 0) {
      toast.error('Please Choose a plan');
      setSubmitLoading(true); // Stop loading
      return;
    }

    if (UserData._id) {

      // Prepare data for submission
      const updatedFormData = {
        ...inputs,
        planId: inputs.plan,
        totalAmount: selectedPlan.price * 1.18,
        UserData,
      };

      try {
        // Send the data to the backend
        const data = await axiosInstance.post(`/buy-plan-by-user`, updatedFormData);

        console.log('dataaa', data)
        const { success, buyPlan } = data.data;
         
         if(success){
         
                  const options = {
                    key: Headers.keyId,
                    amount: buyPlan.Total * 100 ,
                    currency: "INR",
                    name: "Ontech Digital",
                    description: "Ontech Digital Find Local Service Professionals Near You!",
                    image: Headers.meta_logo,
                    order_id: buyPlan.razorpay_order_id,
                    callback_url: `${weburl}paymentverification-plan`,
                    // prefill: {
                    //   name: "test gupta",
                    //   email: "test@gmail.com",
                    //   contact: "1234567890",
                    // },
                    notes: {
                      address: "razorapy official",
                    },
                    theme: {
                      color: "#3399cc",
                    },
                  };
                  const razor = new window.Razorpay(options);
                  razor.open();
         
      
                }

      } catch (error) {
        console.error("Error On Signup:", error);
      } finally {
        // Stop loading after the submission process finishes
        setSubmitLoading(true);
      }



    } else {


      // Validation of form fields
      const fields = [
        { name: "username", message: "Please enter Full Name" },
        { name: "phone", message: "Please enter phone number" },
        { name: "email", message: "Please enter email" },
        { name: "password", message: "Please enter password" },
        { name: "confirm_password", message: "Please enter confirm password" },
        { name: "state", message: "Please enter State" },
        { name: "city", message: "Please enter City" }, // Fix: Change "State" to "City" if needed
        { name: "pincode", message: "Please enter pincode" },
        { name: "address", message: "Please enter address" },
        { name: "pHealthHistory", message: "Please enter past health history" },
        { name: "cHealthStatus", message: "Please enter current health status" },
        { name: "profile", message: "Please upload profile picture " },
  
        ...(inputs.type !== "3"
          ? [
            { name: "Gender", message: "Please enter Gender" },
            { name: "DOB", message: "Please enter DOB" },
          ]
          : []),
      ];

      // Check if all required fields are filled
      for (const field of fields) {
        if (!inputs[field.name]) {
          toast.error(field.message);
          setSubmitLoading(true); // Stop loading
          return;
        }
      }

      // Check if passwords match
      if (inputs.password !== inputs.confirm_password) {
        toast.error("Password does not match");
        setSubmitLoading(true); // Stop loading
        return;
      }

      // Basic email validation
      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      if (!emailRegex.test(inputs.email)) {
        toast.error("Please enter a valid email address");
        setSubmitLoading(true); // Stop loading
        return;
      }

       // Aadhaar Number Validation (12-digit numeric)
    const aadharRegex = /^\d{12}$/;
    if (!aadharRegex.test(inputs.aadharno)) {
      toast.error("Please enter a valid Aadhaar number (12 digits)");
      setSubmitLoading(true);
      return;
    }

      // Date of Birth (DOB) validation (age 18+)
      let dob = new Date(inputs.DOB);
      let today = new Date();
      let age = today.getFullYear() - dob.getFullYear();
      let m = today.getMonth() - dob.getMonth();

      if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) {
        age--;
      }

      // if (age < 18) {
      //   toast.error("You must be at least 18 years old");
      //   setSubmitLoading(true); // Stop loading
      //   return;
      // }

      // Prepare data for submission
      const updatedFormData = {
        ...inputs,
        planId: inputs.plan,
        totalAmount: selectedPlan.price * 1.18,
      };
      console.log('dataaa', updatedFormData)

      try {
        // Send the data to the backend
        const data = await axiosInstance.post(`/buy-plan-add-user`,updatedFormData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

        const { success, user ,paymentData} = data.data;
        if (success) {
          const { _id, username, email, type, phone } = user;
          const userToStore = { _id, username, email, type, phone };

          // Encrypt the user data and set a cookie
          const encryptedData = encrypt(JSON.stringify(userToStore), keyLogin);
          setCookie('token', encryptedData, 7); // Expires in 7 days

          // toast.success("Plan Created Successfully");

          setTimeout(() => {
          
            const handlePayment = (paymentData) => {
              const form = document.createElement('form');
              form.method = 'POST';
              form.action = LiveURL; // PayU's secure payment URL
  
              Object.keys(paymentData).forEach((key) => {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = key;
                input.value = paymentData[key];
                form.appendChild(input);
              });
  
              document.body.appendChild(form);
              form.submit();
            };
  
            handlePayment(paymentData);

          }, 500);
        } else {
          toast.error(data.message || "Something went wrong. Please try again.");
        }
      } catch (error) {
        console.error("Error On Signup:", error);
      } finally {
        // Stop loading after the submission process finishes
        setSubmitLoading(true);
      }

    }

  };



  const fetchData = async () => {
    setLoading(true);
    console.log("response.data start");

    try {
      const response = await axiosInstance.get("/get-all-zones");
      console.log("response.data.Zones,", response.data.Zones);
      setData(response.data.Zones);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  
  useEffect(() => {
    if(OTPVerify && ExistingUser){
      const { _id, username, email, type, phone } = ExistingUser;
      const userToStore = { _id, username, email, type, phone };

      // Encrypt the user data and set a cookie
      const encryptedData = encrypt(JSON.stringify(userToStore), keyLogin);
      setCookie('token', encryptedData, 7); // Expires in 7 days

      setTimeout(() => {
      
        window.location.reload(); // Corrected method to reload the page
      
      }, 500);

    }
  }, [OTPVerify]);

  

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const handleSidebarToggle = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };



  return (
    <>

      <div className="container">
        <div className="d-flex gap-4 justify-content-between p-4 align-items-center">
          {/* Logo */}
          <Link
            className="navbar-brand flex-shrink-0 flex-fill "
            to="/"
            style={{ borderRadius: 5, aspectRatio: "120/25", height: 40 }}
          >
            {Headers.meta_logo && Headers.meta_logo !== undefined ? (
              <img
                src={Headers.meta_logo}
                width={120}
                alt="logo"
                style={{
                  maxHeight: 50,
                  width: "auto",
                  filter: "grayscale(0)",
                  mixBlendMode: "multiply",
                }}
              />
            ) : (
              <div
                className="card-1 skeleton"
                style={{
                  borderRadius: 5,
                  aspectRatio: "142/25",
                  width: "100%",
                  height: 50,
                }}
              ></div>
            )}
          </Link>
          <Link className="btn btn-dark btn-md rounded-xl" to={'/all-plan'} >
            <i class="ri-arrow-left-circle-line text-white"></i> Back</Link>

        </div>
      </div>
      <main className="page  bg-light">
        <div className="container py-4  ">
          <div className="row py-2">
            <div
              className="col-md-8 "
            >
              <div className="card  border-0 p-4 border shadow ">

                <form className="m-b20 row">

                  <div className="col-12 col-md-6">
                    <h4 className="fw-light">Choose Plans</h4>
                    <ul className="customradio input-group one-grid  mb-4 px-0 mx-0">

                      {PlanData.length !== 0 && PlanData.map((row) => (
                        <li>
                          <input
                            type="radio"
                            name="plan"
                            onChange={handleChange}
                            value={row._id}
                            checked={row._id === inputs.plan}
                          />
                          <label className="text-left">
                            <p className="m-0 h5">
                              ₹{row.price} / {row.validity}days
                            </p>
                            <p className="m-0 h6 fw-light"> {row.name}
                            </p> </label>
                        </li>
                      ))}
                    </ul>


                  </div>
                  <hr />

                  {!UserData._id ?
                    <>

<div className='col-md-3 mb-4 col-4'>
                          <div className="openimage-container">
                            <label className="form-label text-dark mb-3 d-block" for="profileImage">Profile Image<span className="text-danger"> ( Required )</span>

                            {inputs.profile && typeof inputs.profile === "string" ? (
                              <img
                                src={inputs.profile !== "" ? weburl + inputs.profile.replace('public\\', '') : "/assets/img/placeholder.png"}
                                id="ProfileImage"
                                alt="Profile Image"
                                className="rounded mt-2"
                                style={{
                                  width: "100%",
                                  aspectRatio: "1/1",
                                  background: "#f8f9fa",
                                  display: "block",
                                  textAlign: "center",
                                  lineHeight: "20vh",
                                  borderRadius: "",
                                  objectFit: "cover",
                                  border: "1px solid grey",
                                }}
                              />
                            ) : (
                              <img
                                src={inputs.profile && typeof inputs.profile === "string" && inputs.profile !== "" ? weburl + inputs.profile.replace('public\\', '') : "/assets/img/placeholder.png"}
                                id="ProfileImage"
                                alt="Profile Image"
                                className="rounded mt-2"
                                style={{
                                  width: "100%",
                                  aspectRatio: "1/1",
                                  background: "#f8f9fa",
                                  display: "block",
                                  textAlign: "center",
                                  lineHeight: "20vh",
                                  borderRadius: "",
                                  objectFit: "cover",
                                  border: "1px solid grey",
                                }}
                              />
                            )}
                            <input
                              type="file"
                              id="profileImage"
                              className="form-control d-none"
                              name="profileImage"
                              accept=".jpg, .jpeg, .png, .webp"
                              capture="camera"  // This will suggest using the camera on mobile devices
                              onChange={(event) => {
                                const file = event.target.files[0];
                                if (file) {
                                  const reader = new FileReader();
                                  reader.onload = (e) => {
                                    const imgElement = document.getElementById("ProfileImage");
                                    if (imgElement) {
                                      imgElement.src = e.target.result; // Set the image URL directly on the img element
                                    }
                                  };
                                  reader.readAsDataURL(file); // Read the file as a data URL
                                  setInputs((prevData) => ({ ...prevData, profile: file })); // Update profile in state
                                }
                              }}
                            />
                            </label>
                          </div>
                        </div>

<div className="col-12"/>

                      <div className="mb-4 col-md-6">
                        <label className="form-label text-dark" htmlFor="name">
                          Full Name <span className="text-danger"> ( Required )</span>
                        </label>
                        <div className="input-group   input-sm">
                          <input
                            type="text"
                            id="username"
                            className="form-control"
                            name="username"
                            value={inputs.username}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="mb-4 col-6">
                        <label className="form-label text-dark" htmlFor="name">
                          Phone <span className="text-danger"> ( Required )</span>
                        </label>
                        <div className=" d-flex gap-2  input-sm">
                          <input
                            type="number"
                            id="phone"
                            className="form-control"
                            name="phone"
                            value={inputs.phone}
                            disabled={OTPVerify}
                            onChange={(e) => {
                              if (e.target.value.length <= 10 && !OTPVerify) {
                                // Check input length before updating
                                handleChange(e); // Call handleChange if length is within limit
                              }
                            }}
                            onInput={(e) => {
                              const inputValue = e.target.value;
                              if (inputValue.length <= 10 && !OTPVerify) {
                                setInputs({ ...inputs, phone: inputValue });
                              }
                            }}
                          // onChange={() => {
                          //   handleChange();
                          // }}
                          />
                        {(GetOtpRes && !OTPVerify) ? 
   <button class="btn btn-primary btn-md w-auto rounded-xl" type="button" onClick={()=>{submitOTP(inputs.phone)}}>Resend OTP</button>
 : !OTPVerify && <button class="btn btn-primary btn-md w-auto rounded-xl" type="button" onClick={()=>{submitOTP(inputs.phone)}}>Send OTP</button>
  } 
                        </div>
                        {(GetOtpRes && !OTPVerify)  && 
                        <div className="mt-4 d-flex gap-2 col-8 bg-light border p-2 rounded">

                          <input
                          type="number"
                          id="otp"
                          className="form-control"
                          name="otp"
                          placeholder="Enter OTP"
                          value={inputs.otp}
                          onChange={(e) => {
                            if (e.target.value.length <= 4) {
                              // Check input length before updating
                              handleChange(e); // Call handleChange if length is within limit
                            }
                          }}
                          onInput={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue.length <= 4) {
                              setInputs({ ...inputs, otp: inputValue });
                            }
                          }}
                        
                        />
                           <button class="btn btn-primary btn-md w-auto rounded-xl" type="button" onClick={()=>{verifyOTPFinal()}}>Verify</button>

                        </div>
                         }
                      </div>
                      <div className="mb-4 col-6">
                        <label className="form-label text-dark" htmlFor="email">
                          Email <span className="text-danger"> ( Required )</span>
                        </label>
                        <div className="input-group   input-sm">
                          <input
                            type="email"
                            id="email"
                            className="form-control"
                            name="email"
                            value={inputs.email}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="mb-4 col-md-6">
                        <label className="form-label text-dark" htmlFor="password">
                          Password <span className="text-danger"> ( Required )</span>
                        </label>
                        <div className="input-group   input-sm">
                          <input
                            type={showPassword ? "text" : "password"}
                            id="password"
                            className="form-control dz-password"
                            name="password"
                            value={inputs.password}
                            onChange={handleChange} // Add onChange handler to manage input changes
                          // onKeyPress={(e) => {
                          //   if (e.key === 'Enter' && inputs.phone.length === 10) {
                          //     submitLoginPass();
                          //   }
                          // }}
                          />
                          <span className="input-group-text text-primary p-1">
                            {/* Toggle password visibility button */}
                            <i
                              className={
                                showPassword
                                  ? "ri-eye-off-fill cursor"
                                  : "ri-eye-fill cursor"
                              }
                              onClick={togglePasswordVisibility}
                            />
                          </span>
                        </div>
                      </div>
                      <div className="mb-4 col-md-6">
                        <label className="form-label text-dark" htmlFor="password">
                          Confirm Password{" "}
                          <span className="text-danger"> ( Required )</span>
                        </label>
                        <div className="input-group   input-sm">
                          <input
                            type={showPassword ? "text" : "password"}
                            id="password"
                            className="form-control dz-password"
                            name="confirm_password"
                            value={inputs.confirm_password}
                            onChange={handleChange} // Add onChange handler to manage input changes
                          // onKeyPress={(e) => {
                          //   if (e.key === 'Enter' && inputs.phone.length === 10) {
                          //     submitLoginPass();
                          //   }
                          // }}
                          />
                          <span className="input-group-text text-primary p-1">
                            {/* Toggle password visibility button */}
                            <i
                              className={
                                showPassword
                                  ? "ri-eye-off-fill cursor"
                                  : "ri-eye-fill cursor"
                              }
                              onClick={togglePasswordVisibility}
                            />
                          </span>
                        </div>
                      </div>

                      {inputs.type !== "3" && (
                        <div className="mb-4 col-6 ">
                          <label className="form-label text-dark" htmlFor="email">
                            Gender <span className="text-danger"> ( Required )</span>
                          </label>
                          <div className="input-group    input-sm">
                            <select
                              className="form-control"
                              value={inputs.gender}
                              name="gender"
                              onChange={handleChange}
                            >
                              <option selected disabled>
                                {" "}
                                Select Gender
                              </option>
                              <option value="1">Male</option>
                              <option value="2">Female</option>
                              <option value="0">Other</option>
                            </select>
                          </div>
                        </div>
                      )}

                      {inputs.type !== "3" && (
                        <div className="mb-4 col-6  ">
                          <label className="form-label text-dark" htmlFor="email">
                            DOB <span className="text-danger"> ( Required )</span>
                          </label>
                          <div className="input-group    input-sm">
                            
                            <input
                              type="date"
                              id="DOB"
                              className="form-control custom-date"
                              name="DOB"
                              value={inputs.DOB}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      )}

                      <div className="mb-4 col-6  ">
                        <label className="form-label text-dark" htmlFor="email">
                          State <span className="text-danger"> ( Required )</span>
                        </label>
                        <div className="input-group    input-sm">
                          <select
                            className="form-control"
                            id="state"
                            name="state"
                            value={inputs.state}
                            onChange={handleChange}
                          >
                            <option selected disabled>
                              {" "}
                              {loading ? "Loading..." : "Select State"}
                            </option>
                            {data.map((item) => (
                              <option key={item._id} value={item._id}>
                                {item.name}
                              </option>
                            ))}{" "}
                            ;
                          </select>
                        </div>
                      </div>

                      <div className="mb-4 col-6 ">
                        <label className="form-label text-dark" htmlFor="city">
                          City <span className="text-danger"> ( Required )</span>
                        </label>
                        <div className="input-group    input-sm">
                          <select
                            className="form-control"
                            id="city"
                            name="city"
                            value={inputs.city}
                            onChange={handleChange}
                          >
                            <option selected value={""}>
                              {" "}
                              {loading ? "Loading..." : "Select City"}
                            </option>
                            {filteredCities.map((city, index) => (
                              <option key={index} value={city}>
                                {city}
                              </option>
                            ))}{" "}
                            ;
                          </select>
                        </div>
                      </div>

                      <div className="mb-4 col-6  ">
                        <label className="form-label text-dark" htmlFor="email">
                          Pincode <span className="text-danger"> ( Required )</span>
                        </label>
                        <div className="input-group    input-sm">
                          <input
                            type="number"
                            id="pincode"
                            className="form-control custom-date"
                            name="pincode"
                            value={inputs.pincode}
                            onChange={handleChange}
                          />
                        </div>
                      </div>

{/* 
     <div className="mb-4 col-md-6 d-none">
                          <label className="form-label text-dark" htmlFor="name">
                            Aadhar Number
                            <span className="text-danger"> ( Required )</span>
                          </label>
                          <div className="input-group   input-sm">
                            <input
                              type="number"
                              id="aadharno"
                              className="form-control"
                              name="aadharno"
                              value={inputs.aadharno}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
 
                        <div className="mb-4 col-12  d-none">
                          <label className="form-label text-dark" htmlFor="email">
                            Past health history
                            <span className="text-danger"> ( Required )</span>
                          </label>
                          <div className="input-group    input-sm">
                            <textarea
                              id="pHealthHistory"
                              className="form-control custom-date"
                              name="pHealthHistory"
                              value={inputs.pHealthHistory}
                              onChange={handleChange}
                            />
                          </div>
                        </div>

                        <div className="mb-4 col-12  d-none">
                          <label className="form-label text-dark" htmlFor="email">
                            Current health status
                            <span className="text-danger"> ( Required )</span>
                          </label>
                          <div className="input-group    input-sm">
                            <textarea
                              id="cHealthStatus"
                              className="form-control custom-date"
                              name="cHealthStatus"
                              value={inputs.cHealthStatus}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
  */}

                      <div className="mb-4  ">
                        <label className="form-label text-dark" htmlFor="email">
                          Address <span className="text-danger"> ( Required )</span>
                        </label>
                        <div className="input-group    input-sm">
                          <textarea
                            className="form-control"
                            id="address"
                            name="address"
                            onChange={handleChange}
                            rows="2"
                          >
                            {inputs.address}
                          </textarea>
                        </div>
                      </div>


                    </> : <>
                      <h4>Welcome {UserData.username}</h4>
                      <div className="col-md-6">
                        <div className="mb-4">
                          <label className="form-label text-dark" htmlFor="name">
                            Full Name <span className="text-danger"> ( Required )</span>
                          </label>
                          <div className="input-group   input-sm">
                            <input
                              type="text"
                              id="username"
                              className="form-control"
                              name="username"
                              value={UserData.username}
                              readOnly
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-4">
                          <label className="form-label text-dark" htmlFor="name">
                            Email ID <span className="text-danger"> ( Required )</span>
                          </label>
                          <div className="input-group   input-sm">
                            <input
                              type="text"
                              id="email"
                              className="form-control"
                              name="email"
                              value={UserData.email}
                              readOnly
                            />
                          </div>
                        </div>
                      </div>
                    </>}

                </form>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card position-sticky top-0 ">
                <div className="p-3 bg-white bg-opacity-10 shadow">
                  <h5 className="card-title mb-3">Order Summary</h5>
                  <hr />


                  <div className="d-flex justify-content-between mb-1 h5 fw-light">
                    <span>Subtotal</span>
                    <span> ₹
                      {
                        (PlanData.find(row => row._id === inputs.plan)?.price || 0)
                      }
                    </span>
                  </div>

                  <div className="d-flex justify-content-between mb-1 fw-light">
                    <span>TAX</span>
                    <span> ₹
                    {
      ((PlanData.find(row => row._id === inputs.plan)?.price || 0) * 1.18 - (PlanData.find(row => row._id === inputs.plan)?.price || 0)).toFixed(2)
    }  

                    </span>
                  </div>

                  <hr />

                  <div className="d-flex justify-content-between mb-4 fw-light">
                    <span>TOTAL</span>
                    <strong className="text-dark"> ₹
                      {
                        // Calculate Total Amount (including tax)
                        (PlanData.find(row => row._id === inputs.plan)?.price || 0) * 1.18
                      }
                    </strong>
                  </div>

                  {SubmitLoading ? (
                    <button
                      className="btn btn-primary btn-md w-100 rounded-xl"
                      type="button"
                      onClick={handleSubmit}
                    >

                      Order Plan
                    </button>
                  ) : (
                    <button
                      disabled
                      className="btn btn-primary btn-md w-100 rounded-xl"
                      type="button"
                    >
                      <span className="ms-1">Loading...</span>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    </button>
                  )}


                </div>
              </div>

            </div>
          </div>

        </div>
      </main>

    </>
  );
};

export default CheckoutPlan;
